/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-29 14:27
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-06-24 09:19
 * @FilePath: \glyun_web_Vue3\src\router\navMenu.js
 * @Description: 导航菜单
 */
export default [
  {// 导航菜单
    path: '/nav',
    redirect: '/overview/plantStation',
    name: 'nav',
    // component: resolve => require(['@/views/headerMenu/home.vue'], resolve),
    component: () => import('@/views/nav/index.vue'),
    children: [
      {
        path: 'dataV',
        name: 'navDataV',
        component: () => import('@/views/nav/function/dataV/index.vue'),
        meta: {
          title: 'v2_router_label23'
        }
      },
      {
        path: 'messageList',
        name: 'navMessageList',
        // component: () => import('@/views/nav/function/messageList/index.vue'),
        children: [
          {
            path: '',
            name: 'navMessageList/',
            component: () => import('@/views/nav/function/message/index.vue'),
            meta: {
              title: "信息中心"
            },
          },
          {
            path: 'details/:pk/:id',
            name: 'navMessageListDetails',
            component: () => import('@/views/nav/function/message/details/index.vue'),
            meta: {
              title: "信息中心"
            },
          }
        ]
      },
      {
        path: 'myCollection',
        name: 'navMyCollection',
        component: () => import('@/views/nav/function/myCollection/index.vue'),
        meta: {
          title: 'v2_plant_my_favorites'
        }
      },
      {
        path: 'myInfo',
        name: 'navMyInfo',
        component: () => import('@/views/nav/function/myInfo/index.vue'),
        meta: {
          title: "我的",// 标题
        }
      },
    ]
  },
]
